import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [token, setToken] = useState(() => localStorage.getItem("masterfit_admin_token") || "");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [tab, setTab] = useState("applications");
  const [data, setData] = useState({ applications: [], newsletter: [], contact: [] });
  const [stats, setStats] = useState({ applications: 0, newsletter: 0, contacts: 0 });
  const [loading, setLoading] = useState(false);

  const fetchAll = async (t) => {
    setLoading(true);
    try {
      const headers = { Authorization: `Bearer ${t}` };
      const [a, n, c, s] = await Promise.all([
        axios.get(`${API}/applications`, { headers }),
        axios.get(`${API}/newsletter`, { headers }),
        axios.get(`${API}/contact`, { headers }),
        axios.get(`${API}/admin/stats`, { headers }),
      ]);
      setData({ applications: a.data, newsletter: n.data, contact: c.data });
      setStats(s.data);
    } catch (e) {
      setErr("Sesión expirada o token inválido.");
      setToken("");
      localStorage.removeItem("masterfit_admin_token");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) fetchAll(token);
  }, [token]);

  const login = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const res = await axios.post(`${API}/admin/login`, { password: pwd });
      localStorage.setItem("masterfit_admin_token", res.data.token);
      setToken(res.data.token);
    } catch {
      setErr("Contraseña incorrecta.");
    }
  };

  const logout = () => {
    localStorage.removeItem("masterfit_admin_token");
    setToken("");
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-4" data-testid="admin-login">
        <form onSubmit={login} className="w-full max-w-sm glass-card p-8">
          <div className="font-display text-3xl uppercase mb-2">Admin <span className="text-[#FF6B00]">Masterfit</span></div>
          <p className="text-sm text-zinc-400 mb-6">Acceso protegido. Ingresa la contraseña.</p>
          <input
            type="password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            placeholder="Contraseña"
            className="mf-input mb-4"
            data-testid="admin-password"
          />
          <button type="submit" className="w-full bg-[#FF6B00] text-black py-3 font-bold tracking-[0.25em] uppercase btn-glow text-xs" data-testid="admin-login-submit">
            Entrar
          </button>
          {err && <div className="mt-4 text-red-400 text-sm" data-testid="admin-error">{err}</div>}
        </form>
      </div>
    );
  }

  const list = data[tab];

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white p-6 lg:p-10" data-testid="admin-dashboard">
      <header className="flex flex-wrap items-center justify-between gap-4 mb-10">
        <div>
          <div className="font-display text-3xl uppercase">Admin <span className="text-[#FF6B00]">Masterfit</span></div>
          <div className="text-xs text-zinc-500 tracking-widest uppercase mt-1">Dashboard</div>
        </div>
        <button onClick={logout} className="text-xs tracking-[0.25em] uppercase border border-white/15 px-4 py-2 hover:border-[#FF6B00] hover:text-[#FF6B00] transition">
          Cerrar sesión
        </button>
      </header>

      <div className="grid grid-cols-3 gap-4 mb-8">
        {[
          { k: "applications", label: "Aplicaciones", val: stats.applications },
          { k: "newsletter", label: "Newsletter", val: stats.newsletter },
          { k: "contact", label: "Contactos", val: stats.contacts },
        ].map((s) => (
          <button
            key={s.k}
            onClick={() => setTab(s.k)}
            className={`glass-card p-6 text-left transition lift-card ${tab === s.k ? "ring-1 ring-[#FF6B00]" : ""}`}
            data-testid={`stat-tab-${s.k}`}
          >
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">{s.label}</div>
            <div className="font-display text-5xl mt-2">{s.val}</div>
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-zinc-500">Cargando...</div>
      ) : (
        <div className="glass-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-xs tracking-[0.2em] uppercase text-zinc-500 border-b border-white/10">
                <tr>
                  <th className="text-left p-4">Fecha</th>
                  {tab === "applications" && (
                    <>
                      <th className="text-left p-4">Nombre</th>
                      <th className="text-left p-4">Email</th>
                      <th className="text-left p-4">IG</th>
                      <th className="text-left p-4">Nivel</th>
                      <th className="text-left p-4">Presupuesto</th>
                      <th className="text-left p-4">Objetivos</th>
                    </>
                  )}
                  {tab === "newsletter" && (
                    <>
                      <th className="text-left p-4">Email</th>
                      <th className="text-left p-4">Source</th>
                      <th className="text-left p-4">Locale</th>
                    </>
                  )}
                  {tab === "contact" && (
                    <>
                      <th className="text-left p-4">Nombre</th>
                      <th className="text-left p-4">Email</th>
                      <th className="text-left p-4">Mensaje</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {list.length === 0 && (
                  <tr><td colSpan="7" className="p-6 text-zinc-500 text-center">Sin registros aún.</td></tr>
                )}
                {list.map((row) => (
                  <tr key={row.id} className="border-b border-white/5 hover:bg-white/5 transition">
                    <td className="p-4 text-zinc-400 text-xs">{new Date(row.created_at).toLocaleString()}</td>
                    {tab === "applications" && (
                      <>
                        <td className="p-4">{row.name}</td>
                        <td className="p-4 text-zinc-300">{row.email}</td>
                        <td className="p-4 text-zinc-400">{row.instagram || "—"}</td>
                        <td className="p-4">{row.fitness_level}</td>
                        <td className="p-4 text-[#FF6B00]">{row.budget}</td>
                        <td className="p-4 text-zinc-400 max-w-md truncate">{row.goals}</td>
                      </>
                    )}
                    {tab === "newsletter" && (
                      <>
                        <td className="p-4">{row.email}</td>
                        <td className="p-4 text-zinc-400">{row.source}</td>
                        <td className="p-4 text-zinc-400 uppercase">{row.locale}</td>
                      </>
                    )}
                    {tab === "contact" && (
                      <>
                        <td className="p-4">{row.name}</td>
                        <td className="p-4 text-zinc-300">{row.email}</td>
                        <td className="p-4 text-zinc-400 max-w-md truncate">{row.message}</td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
